import { Component } from '@angular/core';

@Component({
  selector: 'router-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent {}
